import { Tab, Tabs } from 'react-bootstrap';

import { window } from '../../../globals';
import { SupportLink } from '../../generic/Link';
import Text from '../../generic/Text';
import BillingHeader from './BillingHeader';
import CurrentPlanContent from './CurrentPlanContent';
import InvoiceHistoryContent from './InvoiceHistoryContent';
import PaymentMethodContent from './PaymentMethodContent';

const BillingSettings = () => {
  const hasCustomBilling = window.user?.organization.custom_billing;

  return (
    <div className="container margin-top-xl">
      <div className="panel billing-contents">
        <BillingHeader />
        <Tabs defaultActiveKey={1} animation={false} id="billing-settings-tabs">
          <Tab eventKey={1} tabClassName="billing-tab" title="Current Plan">
            {!hasCustomBilling ?
              <CurrentPlanContent /> :
                (
                  <div className="custom-billing-info">
                    <Text.H1>
                      Billing is handled custom for this account.
                    </Text.H1>
                    <br />
                    <SupportLink>Contact support</SupportLink> with any questions or concerns.
                  </div>
                )}
          </Tab>
          {/* We can't group these conditionals into one because bootstrap `Tab` need to be the direct child `Tabs`. */}
          {!hasCustomBilling && (
          <Tab eventKey={2} tabClassName="billing-tab" title="Invoice History">
            <InvoiceHistoryContent />
          </Tab>
          )}
          {/* The PaymentMethod tab unmounts on exit so that it resets to original state when navigated away from. */}
          {!hasCustomBilling && (
          <Tab eventKey={3} tabClassName="billing-tab" title="Payment Method" unmountOnExit>
            <PaymentMethodContent />
          </Tab>
          )}
        </Tabs>
      </div>
    </div>
  );
};

export default BillingSettings;
